import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { WorkOrderCasesEntityEffects } from './work-order-cases.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([WorkOrderCasesEntityEffects])],
})
export class WorkOrderCaseEntityModule {}
